module.exports = __webpack_public_path__ + "img/logo.e02d8c3b.svg";